import { FiX } from "react-icons/fi";
import dayjs from "dayjs";
import { FiBell } from "react-icons/fi";

type AlarmNotificationProps = {
  alarm: any;
  onDismiss: () => void;
};

const AlarmNotification = ({ alarm, onDismiss }: AlarmNotificationProps) => {
  if (!alarm) return null;

  const name = alarm?.tagName || alarm?.name || "Alarm";
  const status = "Nominal Values Exceeded";
  const timestamp = alarm?.createdOn
    ? `${dayjs(alarm.createdOn).format("MM/DD/YYYY")}, ${dayjs(alarm.createdOn).format("HH:mm:ss")}`
    : "";
  const value = alarm?.tagValue ?? alarm?.value;

  const messageParts = [
    name,
    status,
    timestamp && `at ${timestamp}`,
    value !== undefined && `value: ${value}`,
  ].filter(Boolean);

  return (
    <div className="fixed top-14 right-4 z-[9999] max-w-sm bg-black text-white border border-red rounded-md shadow-lg flex items-start gap-3">
      <div className="flex items-center gap-2 bg-red/25 p-3 relative">
        <div className="flex-1 flex gap-2">
          <FiBell size={40} className="text-red" />
          <p className="text-sm 2xl:text-base font-semibold break-words pr-10">
            {messageParts.join(" · ")}
          </p>
        </div>
        <button
          type="button"
          className=" absolute top-2 right-2 cursor-pointer bg-red rounded-md p-1 flex items-center justify-center"
          onClick={onDismiss}
        >
          <FiX size={16} />
        </button>
      </div>
    </div>
  );
};

export default AlarmNotification;

